import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Shield, CheckCircle2, Award, Lock } from "lucide-react";

export default function RegulationsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <section className="flex-1 max-w-4xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">
            Regulations & <span className="gold-grad">Compliance</span>
          </h1>
          <p className="text-white/60 text-lg">
            Duocapital operates under strict regulatory compliance and maintains the highest standards of financial security.
          </p>
        </div>

        <div className="space-y-8">
          {/* Business License */}
          <div className="glass-strong rounded-2xl p-8 border-l-4 border-[#D4AF37]">
            <div className="flex items-start gap-4">
              <Award className="w-8 h-8 text-[#D4AF37] flex-shrink-0 mt-1" />
              <div className="flex-1">
                <h2 className="font-display text-2xl font-bold mb-2">Business License & Registration</h2>
                <div className="space-y-2 text-white/70">
                  <p><span className="font-semibold text-white">Company:</span> Duocapital Investment Services Ltd.</p>
                  <p><span className="font-semibold text-white">License Number:</span> DCAP-2022-001847</p>
                  <p><span className="font-semibold text-white">Registered in:</span> Malta Financial Services Authority</p>
                  <p><span className="font-semibold text-white">Registration Date:</span> January 15, 2022</p>
                  <p><span className="font-semibold text-white">Status:</span> <span className="text-[#00D68F]">Active & Verified</span></p>
                </div>
              </div>
            </div>
          </div>

          {/* Financial Regulation */}
          <div className="glass-strong rounded-2xl p-8 border-l-4 border-[#00D68F]">
            <div className="flex items-start gap-4">
              <Shield className="w-8 h-8 text-[#00D68F] flex-shrink-0 mt-1" />
              <div className="flex-1">
                <h2 className="font-display text-2xl font-bold mb-2">Financial Regulation</h2>
                <ul className="space-y-2 text-white/70">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-[#00D68F] flex-shrink-0 mt-0.5" />
                    <span>Compliant with GDPR - EU Data Protection Regulation</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-[#00D68F] flex-shrink-0 mt-0.5" />
                    <span>AML/KYC - Anti-Money Laundering & Know Your Customer procedures</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-[#00D68F] flex-shrink-0 mt-0.5" />
                    <span>PSD2 Compliant - Payment Services Directive 2</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-[#00D68F] flex-shrink-0 mt-0.5" />
                    <span>Cryptocurrency Compliance - Registered with FinCEN</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Security & Audits */}
          <div className="glass-strong rounded-2xl p-8 border-l-4 border-blue-500">
            <div className="flex items-start gap-4">
              <Lock className="w-8 h-8 text-blue-400 flex-shrink-0 mt-1" />
              <div className="flex-1">
                <h2 className="font-display text-2xl font-bold mb-2">Security & Audits</h2>
                <ul className="space-y-2 text-white/70">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                    <span>Annual Third-Party Security Audits (Last: March 2024)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                    <span>ISO 27001 Certified - Information Security Management</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                    <span>Bank-Grade Encryption - AES-256 & TLS 1.3</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                    <span>Multi-Signature Wallets - Crypto Cold Storage</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Risk Disclosure */}
          <div className="glass-strong rounded-2xl p-8 bg-red-500/5 border border-red-500/30">
            <h3 className="font-display text-xl font-bold mb-4 text-red-300">Risk Disclosure</h3>
            <p className="text-white/70 mb-4">
              Cryptocurrency and investment trading carry significant risks. Past performance does not guarantee future results. Users should only invest what they can afford to lose and conduct their own due diligence.
            </p>
            <p className="text-sm text-white/60">
              For full regulatory disclosures and risk documents, please contact our compliance team at compliance@duocapital.com
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
